import { render, staticRenderFns } from "./MigrateCDP.vue?vue&type=template&id=2655408a&scoped=true&"
import script from "./MigrateCDP.vue?vue&type=script&lang=js&"
export * from "./MigrateCDP.vue?vue&type=script&lang=js&"
import style0 from "./MigrateCDP.vue?vue&type=style&index=0&id=2655408a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2655408a",
  null
  
)

export default component.exports